import React, { Component } from 'react';
import Video from 'twilio-video';
import Spinner from 'react-bootstrap/Spinner'
import config from '../config';

import { StringUtils, ArrayUtils } from '../utils';
import { Routes as routes } from '../navigation';
import '../css/SingleScreens/ConsultationScreen.css';

class VideoCall extends Component {

  constructor(props) {
    super(props);
    this.state = {
      videoCallToken: '',
      identity: null,
      roomName: '',
      roomNameErr: false,
      localMediaAvailable: false,
      hasJoinedRoom: false,
      activeRoom: null,
      participantStatusChange: false,
      estimatedAmount: 0,
      secondsElapsed: 0,
      displayTimerText: '',
      interval: null,
      twilioTokenLoading: false,
    }
  }

  componentDidMount() {
    if (this.props.consultationId && this.props.token) {
      const estimatedAmount = this.props.consultation && this.props.consultation.final_amount ? this.props.consultation.final_amount : 0;
      this.props.videoCallActions.getVideoCallToken(this.props.token, this.props.consultationId, this.setTokenAndIdentity);
      this.setState({ ...this.state, roomName: this.props.consultationId, twilioTokenLoading: true });
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  joinRoom = () => {
    if (!this.state.roomName.trim()) {
        this.setState({ roomNameErr: true });
        return;
    }

    let connectOptions = {
        name: this.state.roomName,
    };

    Video.connect(this.state.videoCallToken, connectOptions).then(this.roomJoined, error => {
        alert('Could not connect to Twilio: ' + error.message);
    });
  }

  roomJoined = (room) => {

    this.setState({
      activeRoom: room,
      localMediaAvailable: true,
      hasJoinedRoom: true,
    });

    var localMediaContainer = this.refs.localMedia;
    this.attachParticipantTracks(room.localParticipant, localMediaContainer);

    //Participants already in the Room when logged in user joins
    room.participants.forEach(participant => {
      var remoteContainer = this.refs.remoteMedia;
      participant.tracks.forEach(publication => {
        if (publication.isSubscribed) {
          const track = publication.track;
          remoteContainer.appendChild(track.attach());
        }
      });
      participant.on('trackSubscribed', function (track) {
        remoteContainer.appendChild(track.attach());
      });
      const that = this;
      participant.on('trackUnsubscribed', function (track) {
        that.detachTrack(track)
      });
      this.setState({ ...this.state, participantStatusChange: !this.state.participantStatusChange });
    });

    room.on('participantConnected', participant => {
      console.log("Joining: '" + participant.identity + "'");
      var remoteContainer = this.refs.remoteMedia;
      var t = setInterval(this._onEverySecondProvider, 1000);
      participant.tracks.forEach(publication => {
        if (publication.isSubscribed) {
          const track = publication.track;
          remoteContainer.appendChild(track.attach());
        }
      });
      participant.on('trackSubscribed', function (track) {
        remoteContainer.appendChild(track.attach());
      });

      const that = this;
      participant.on('trackUnsubscribed', function (track) {
        that.detachTrack(track)
      });

      this.setState({ ...this.state, participantStatusChange: !this.state.participantStatusChange, interval: t });
    });

    room.on('participantDisconnected', participant => {
      clearInterval(this.state.interval);
      this.setState({ ...this.state, participantStatusChange: !this.state.participantStatusChange });
    });

    room.on('disconnected', () => {
      this.detachParticipantTracks(room.localParticipant);
      room.participants.forEach(this.detachParticipantTracks);
      this.state.activeRoom = null;
      this.setState({ hasJoinedRoom: false, localMediaAvailable: false });
    });
  }

  leaveRoom = () => {
    if (this.state.activeRoom) {
      this.state.activeRoom.disconnect();
    }
    if (this.props.endCallAction) {
      this.props.endCallAction();
    }
    this.setState({ hasJoinedRoom: false, localMediaAvailable: false });
  }

  _onEverySecondProvider = () => {
    const currentPractice = this.props.practice;
    const isBehavioral = currentPractice && currentPractice.type && currentPractice.type === 'BEHAVIOR' ? true : false;
    //
    let currentSeconds = this.state.secondsElapsed;
    let newSeconds = currentSeconds + 1;
    //
    let timerSeconds = isBehavioral ? 1200 : 600; // 10 Minute (600 seconds) Timer
    let remainingSeconds = timerSeconds - newSeconds;
    let countUp = currentSeconds - timerSeconds;
    let displaySeconds = countUp >= 0 ? countUp + timerSeconds : remainingSeconds;
    //
    let mins = Math.floor(displaySeconds/60);
    let seconds = displaySeconds % 60;
    let minsString = mins.toString();
    let secondsString = seconds.toString().length < 2 ? '0' + seconds.toString() : seconds.toString();
    let timerText = minsString + ":" + secondsString;

    this.setState({ ...this.state, secondsElapsed: newSeconds, displayTimerText: timerText })
  }

  renderVideoCall = (consultationId) => {
    if (!consultationId) {
      return null
    }

    const showLocalTrack = <div><div id='consultation-local-media' ref="localMedia" /></div>;
    const remoteContainerPopulated = this.refs.remoteMedia && this.refs.remoteMedia.children && this.refs.remoteMedia.children.length > 0 ? true : false;
    const displayWaitingForParticipant = !remoteContainerPopulated && this.state.hasJoinedRoom ? true : false;
    const displayStartCall = this.state.hasJoinedRoom ? false : true;

    return <div className="basic-container consultation-screen-video-call-container" style={{ marginBottom: 200 }}>

      { this.renderStartCallSection(displayStartCall) }
      { this.renderWaitingSection(displayWaitingForParticipant) }
      { this.state.hasJoinedRoom ? <div id="remote-media" ref="remoteMedia"  /> : null }

      <div className='flex-container-row' style={{ marginTop: 10 }}>
      { showLocalTrack }
        <div className='flex-container-row' style={{ marginLeft: this.state.hasJoinedRoom ? 10 : 0, alignItems: 'center', justifyContent: 'space-between', flex: 1 }}>
          <input  type='submit'
                  value={ this.state.hasJoinedRoom ? 'End Call' : 'Exit' }
                  className={'button-default'}
                  style={{ backgroundColor: this.state.hasJoinedRoom ? 'red' : '#1dc2ff', borderRadius: this.state.hasJoinedRoom ? 20 : 5 }}
                  onClick={ () => {
                    const consultation_id = consultationId;
                    const token = this.props.token;
                    console.log("RIGHT BEFORE END CALL")
                    if (consultation_id && token && this.state.hasJoinedRoom) {
                      console.log("END CALL NOTIFICATION SENT")
                      this.props.videoCallActions.endCallNotification(token, consultation_id);
                    }
                    this.leaveRoom()
                  }}
                />
          <div className='flex-container-column' style={{ alignItems: 'flex-end' }}>
            <span style={{ marginTop: 5, color: '#1dc2ff', fontSize: 22, fontWeight: 'bold' }}>{ this.state.displayTimerText }</span>
            <span style={{ color: 'grey', fontSize: 14, marginTop: -5 }}>{ this.state.displayTimerText ? 'Time Remaining' : '' }</span>
          </div>
        </div>
      </div>


    </div>
  }

  renderStartCallSection = (display) => {
    if (!display) {
      return null;
    }

    let consultation   = this.props.consultation;
    let client         = ArrayUtils.getSingleObject(consultation.client);
    let displayClient  = client && client.first_name ? true : false;
    let hideChargeInfo = consultation && consultation.no_charge ? true : false;
    let service_fee    = config.SERVICE_FEE || 0.08;

    return <div className='start-call-section'>
      { client.photo_url ? <img className="user-profile-profile-image" src={client.photo_url} />
      : <span className="fas fa-user-circle" style={{ fontSize: 40, color: '#e9e9e9' }}></span> }
      <span style={{ fontSize: 18, marginTop: 5, marginBottom: 5 }}>{ StringUtils.displayName(client) }</span>

        { hideChargeInfo ? null : <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'center' }}>
          <span className="fas fa-dollar-sign" style={{ fontSize: 20, color: '#1dc2ff', marginRight: 5 }}></span>
          <input  className="input-default"
                  style={{ margin: 10, marginLeft: 0, marginBottom: 0, textAlign: 'center', width: 70 }}
                  placeholder="0.00"
                  value={this.state.estimatedAmount}
                  type="number"
                  onChange={ (event) => {
                    this.setState({ ...this.state, estimatedAmount: event.target.value })
                  }}
          />
        </div> }

       { hideChargeInfo ? null : <span style={{ fontSize: 14, marginTop: 3, marginBottom: 15, color: 'grey' }}>Enter Estimated Charge</span> }

        <div className='flex-container-row' style={{ alignItems: 'center', justifyContent: 'center' }}>
          <span className="fas fa-dollar-sign" style={{ fontSize: 20, color: '#1dc2ff', marginRight: 5 }}></span>
          <span style={{ fontSize: 18, color: 'grey', width: 80, textAlign: 'center', paddingRight: 20 }}>{ (this.state.estimatedAmount * (1 + service_fee)).toFixed(2) || 0 }</span>
        </div>
        <span style={{ fontSize: 14, marginTop: 3, marginBottom: 15, color: 'grey' }}>Amount Client will be charged</span>


      <span className='start-call-button'
            onClick={ () => {

              if (this.state.twilioTokenLoading) { return }

              const estimateAmount = this.state.estimatedAmount;
              const token = this.props.token;
              const consultationId = this.props.consultationId;
              if (estimateAmount > 0) {
                const dollarAmount = estimateAmount;
                const centsAmount  = dollarAmount * 100;
                const cleanedCents = Number(centsAmount.toFixed(2));
                if (!isNaN(cleanedCents) && token && consultationId) {
                  this.props.videoCallActions.updateVideoCallEstimateAmount(token, consultationId, centsAmount);
                }
              }
              if (estimateAmount === 0) {
                this.props.videoCallActions.updateVideoCallEstimateAmount(token, consultationId, 0);
              }
              const consultation_id = consultation && consultation._id ? consultation._id : '';
              if (consultation_id && token) {
                this.props.videoCallActions.startCallNotification(token, consultation_id);
              }
              this.joinRoom();
            }}>
        { this.state.twilioTokenLoading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white' }} />
                                        : <span className="fas fa-video" style={{ fontSize: 15, color: 'white' }}></span> }
        <span style={{ fontSize: 14, fontWeight: 'bold', marginLeft: 10, color: 'white' }}>Start Video Call</span>
      </span>
    </div>
  }

  renderWaitingSection = (display) => {
    if (!display) {
      return null;
    }

    const consultation  = this.props.consultation;
    const client        = ArrayUtils.getSingleObject(consultation.client);

    return <div className='start-call-section' style={{ borderWidth: 0, backgroundColor: '#bbecff' }}>
      <div className='flex-container-column' style={{ backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', padding: 20, borderRadius: 10 }}>
        { client.photo_url ? <img className="user-profile-profile-image" src={client.photo_url} />
        : <span className="fas fa-user-circle" style={{ fontSize: 40, color: '#e9e9e9' }}></span> }
        <span style={{ fontSize: 18, marginTop: 5, marginBottom: 5 }}>{ StringUtils.displayName(client) }</span>
        <span className='flex-container-row' style={{ alignItems: 'center' }}>
          <Spinner as="span" animation="border" size='sm' style={{ color: '#1dc2ff' }} />
          <span style={{ marginLeft: 8, fontSize: 14, color: 'grey' }}>{ 'Waiting for ' + StringUtils.sentenceCase(client.first_name) + ' to join...' }</span>
        </span>
      </div>
    </div>
  }

  render() {
    return this.renderVideoCall(this.props.consultationId);
  }

  attachParticipantTracks = (participant, container) => {
    var tracks = Array.from(participant.tracks.values());
    this.attachTracks(this.getTracks(participant), container);
  }

  attachTracks = (tracks, container) => {
    tracks.forEach( (track) => {
      this.attachTrack(track, container);
    });
  }

  attachTrack = (track, container) => {
    container.appendChild(track.attach());
  }

  getTracks = (participant) => {
    return Array.from(participant.tracks.values()).filter( (publication) => {
      return publication.track;
    }).map( (publication) => {
      return publication.track;
    });
  }

  detachTrack = (track) => {
    track.detach().forEach( (element) => {
      element.remove();
    });
  }

  detachTracks = (tracks) => {
    tracks.forEach(track => {
      track.detach().forEach(detachedElement => {
        detachedElement.remove();
      });
    });
  }

  detachParticipantTracks = (participant) => {
    var tracks = this.getTracks(participant);
    tracks.forEach(this.detachTrack);
  }

  setTokenAndIdentity = (twilioToken, identity) => {
    if (twilioToken && identity) {
      this.setState({ ...this.state, videoCallToken: twilioToken, identity: identity, twilioTokenLoading: false });
    }
  }

}


export default VideoCall
